
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import { Vendedor } from '@/__env/lib/Ventas/Vendedores';
    import item from './lista-mini-item.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            item,

        }
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorInterfaz;
        @Prop() public Vendedor: Vendedor;
        @Prop() public Items: Vendedor[];
        @Prop() public Seleccionado: number;
        @Prop() public Busqueda: string;


        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }

        mounted()
        {


        }

    }
